'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var endpoint = require('./endpoint.js');
var memory = require('./memory.js');
var channel = require('./strategies/channel.js');
var messenger = require('./strategies/messenger.js');
var messagePort = require('./adaptors/message-port.js');
var webWorker = require('./adaptors/web-worker.js');
var types = require('./types.js');



exports.createEndpoint = endpoint.createEndpoint;
exports.StackFrame = memory.StackFrame;
exports.release = memory.release;
exports.retain = memory.retain;
exports.createChannelFunctionStrategy = channel.createChannelFunctionStrategy;
exports.createMessengerFunctionStrategy = messenger.createMessengerFunctionStrategy;
exports.fromMessagePort = messagePort.fromMessagePort;
exports.fromWebWorker = webWorker.fromWebWorker;
exports.RELEASE_METHOD = types.RELEASE_METHOD;
exports.RETAINED_BY = types.RETAINED_BY;
exports.RETAIN_METHOD = types.RETAIN_METHOD;
